import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { StyledLink } from 'src/components/base/styledComponents';
import ProfileModel from 'src/models/account/ProfileModel';
import InputDefinitionBuilder from '../../../../utils/inputDefinitions/InputDefinitionBuilder';
import CheckboxField from '../../checkbox/CheckboxField';

interface ITermsAndConditionsField {
  model: ProfileModel;
}

const TermsAndConditionsField: React.FC<ITermsAndConditionsField> = (props: ITermsAndConditionsField) => {
  const link = <StyledLink href={'/Info/TermsOfService'}>Terms and Conditions</StyledLink>;
  const [inputDefinition] = React.useState(new InputDefinitionBuilder(`I have read the terms and conditions`).WithRequiredTextBoxField().Build());

  return (
    <>
    <CheckboxField
      name='policy'
      value={props.model.policy}
      inputDefinition={inputDefinition}
      onModelChange={props.model.OnModelChange}
      
      />
      {link}
      </>
  );
};

export default observer(TermsAndConditionsField);
